





































import Vue from 'vue';
import Icon from '../Icon/Icon.vue';

interface Tab {
  isActive: boolean;
  isLocked: boolean;
  name: string;
  icon: string;
}

interface Data {
  tabs: Array<Tab>;
}

interface Provider {
  addTab: Function;
}

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    v2: {
      type: Boolean,
      default: false,
    },
    spaced: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      tabs: [],
    };
  },
  methods: {
    selectTab(selectedTab: Tab) {
      this.tabs.forEach((tab: Tab) => {
        tab.isActive = tab.name == selectedTab.name;
      });
      this.$emit('selected', selectedTab.name);
    },
    addTab(item: Tab) {
      this.tabs.push(item);
    },
  },
  provide: function (): Provider {
    return {
      addTab: this.addTab,
    };
  },
});
